<template>
  <div class="app-wrapper">
    <header class="top-header">
      <div class="header-brand">
        <div class="brand-mark">T</div>
        <div class="brand-info">
          <span class="brand-name">thxily</span>
          <span class="brand-sub">管理コンソール</span>
        </div>
      </div>
      <button class="back-btn" v-on:click="$router.push('/menu')">← メニューへ戻る</button>
    </header>
    <main class="main-content">
      <div class="white-card">
        <h1 class="page-title">ユーザー一覧</h1>
        <table class="data-table">
          <thead>
            <tr>
              <th>アイコン</th>
              <th>氏名</th>
              <th>ID</th>
              <th>メールアドレス</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id" v-on:click="to_user(user.id)" style="cursor:pointer;">
              <td><img :src="user.image" class="user-avatar" /></td>
              <td>{{ user.name }}</td>
              <td>{{ user.user_identifier }}</td>
              <td>{{ user.email }}</td>
              <td><button class="btn-primary" v-on:click.stop="to_user(user.id)">編集</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import store from "@/store";
const  DUMMY_IMG =  "data:image/png;base64,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"
export default {
  data: function () {
    return {
      users: [],
    }
  },
  async mounted(url, config) {
    let data = {
      no_image: "true",
      is_with_nonuser: true
    }
    await axios.get("/users", {params: data}).then((response) => {
      response.data.forEach(function(x){
        x.image = DUMMY_IMG
        this.users.push(x)
      }, this)
    });
    this.users.forEach((user) => {
      this.getImg(user.id)
    });
  },
  methods: {
    getImg: async function(user_id) {
      let data = {
        user_id: user_id
      };
      await axios.get("/user_image", {params: data}).then((response) => {
        let img = response.data[0]?.image
        let u = this.users.find(x => x.id === user_id)
        if (u && img) {
          u.image = img
        }
      });
    },
    to_user: function (user_id) {
      router.push("/user/" + user_id)
    },
    logout: function() {
      store.dispatch("logout")
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');

.app-wrapper {
  min-height: 100vh;
  background: #DDE2EC;
  font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
}

.top-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  height: 64px;
  background: #1E2A3A;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.header-brand { display: flex; align-items: center; gap: 12px; }

.brand-mark {
  width: 38px; height: 38px; border-radius: 10px;
  background: linear-gradient(135deg, #4F8EF7, #7C5CFC);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.1rem; font-weight: 800; color: #fff;
}

.brand-info { display: flex; flex-direction: column; line-height: 1.2; }
.brand-name { font-size: 1rem; font-weight: 700; color: #fff; }
.brand-sub  { font-size: 0.68rem; color: #8A9BB0; }

.back-btn {
  padding: 8px 20px; border-radius: 8px;
  border: 1.5px solid #94A3B8; background: transparent;
  color: #94A3B8; font-size: 0.85rem; font-weight: 600;
  cursor: pointer; font-family: inherit;
  transition: background 0.2s, color 0.2s;
}
.back-btn:hover { background: #94A3B8; color: #1E2A3A; }

.main-content {
  max-width: 960px; margin: 0 auto;
  padding: 40px 24px 80px;
}

.white-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.10);
  padding: 32px 40px;
}

.page-title {
  font-size: 1.3rem; font-weight: 700;
  color: #1E293B; margin: 0 0 24px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #E2E8F0;
}

.data-table { width: 100%; border-collapse: collapse; }
.data-table th {
  text-align: left; padding: 12px 16px;
  background: #F8FAFC; color: #475569;
  font-size: 0.8rem; font-weight: 700;
  border-bottom: 2px solid #E2E8F0;
}
.data-table td {
  padding: 14px 16px; border-bottom: 1px solid #F1F5F9;
  font-size: 0.9rem; color: #334155;
}
.data-table tr:hover td { background: #F8FAFC; }

.user-avatar {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
}

.btn-primary {
  padding: 8px 18px; border-radius: 8px; border: none;
  background: #3B82F6; color: #fff;
  font-size: 0.85rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: background 0.2s;
}
.btn-primary:hover { background: #2563EB; }
</style>
